<template>
  <div class="page-container">
	<v-toolbar color="secondary" dark class="headline">
    	<v-toolbar-title>Colores</v-toolbar-title>
	</v-toolbar>
	<v-container fluid>
        <v-layout row wrap>
			<v-flex xs12 sm4 pa-1 v-for="color in colores" :key="color.id">
				<v-card>
				<v-container fluid grid-list-lg>
					<v-layout row wrap>
					<v-flex xs12>
						<div v-if="color.editando!=true" class="headline color-titulo" >{{color.descripcion}}</div>
						<v-text-field :id="'txtColor' + color.id" class="headline input-color"  v-if="color.editando==true" v-model="color.descripcion"></v-text-field>
						<v-card-actions style="padding:0px;margin-top: 10px;justify-content:flex-end">
							<v-btn fab v-if="color.editando==true" style="margin-right:10px!important" color="red" dark @click="cancelar(color)"><v-icon class="fa-fab-icon">fa-times</v-icon></v-btn>
							<v-btn fab v-if="color.editando==true" color="green" dark @click="aceptar(color)"><v-icon class="fa-fab-icon">fa-check</v-icon></v-btn>
							<v-btn fab v-if="color.editando!=true" style="margin-right:10px!important" :disabled="editando" color="red" dark @click="confirmarEliminar(color)"><v-icon class="fa-fab-icon">fa-trash</v-icon></v-btn>
							<v-btn fab v-if="color.editando!=true" :disabled="editando" color="blue" dark @click="setEditando(color)"><v-icon class="fa-fab-icon">fa-pen</v-icon></v-btn>
						</v-card-actions>
					</v-flex>
					</v-layout>
				</v-container>
				</v-card>
			</v-flex>
		</v-layout>
	</v-container>
	<v-btn color="green" :disabled="editando" dark fixed bottom right class="btn-very-large" @click="agregarNuevo()" fab>
		<v-icon>add</v-icon>
    </v-btn>
	<v-snackbar top :color="snackColor" v-model="snackbar">{{ mensaje }}<v-btn color="black" small fab dark @click="snackbar = false"><v-icon class="fa-fab-icon">fa-times</v-icon></v-btn>
    </v-snackbar>
	<v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Eliminar Color</span>
        </v-card-title>
        <v-card-text>
			¿Estás seguro que querés eliminar el color?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" dark @click="onCancelarEliminar()">No</v-btn>
          <v-btn color="blue darken-1" dark @click="onConfirmarEliminar()">Si</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  	<div style="height:80px;width:1px;" v-if="$vuetify.breakpoint.smAndDown">&nbsp;</div>
  </div>
</template>

<script>
export default {
  name: "colores",
  components: {},
  data() {
    return { colores: [],snackbar:false,mensaje:'',snackColor:'success',editando:false,dialog:false,aEliminar:null};
  },
  created() {
    this.obtenerElementos();
  },
  methods: {
    obtenerElementos: function() {
		this.$http.get(this.$root.mainUrl + 'api/colores.php').then(result => {
			result.json().then(elem =>{
				this.colores = elem;
				for(let i=0;i<this.colores.length;i++){
					this.$set(this.colores[i], 'editando', false);
				}
      		});
      	}, error => {
			//   console.error(error);
			this.showMessage('Ocurrió un error al obtener los colores','error');
      	});
	},
	setEditando: function(color){
		color.descripcionBack = color.descripcion;
		color.editando = true;
		this.editando = true;
		this.$nextTick(() => document.getElementById('txtColor' + color.id).focus());
	},
	cancelar: function(color){
		color.descripcion = color.descripcionBack;
		color.editando = false;
		this.editando = false;
		if (color.id==null){
			this.colores.pop();
		}
	},
	confirmarEliminar: function(color){
		this.aEliminar = color;
		this.dialog = true;
	},
	onConfirmarEliminar: function(){
		this.dialog = false;
		this.eliminar(this.aEliminar);
	},
	onCancelarEliminar: function(){
		this.dialog = false;
		this.aEliminar = null;
	},
	eliminar: function(color){
		color.operacion = "ELIMINAR";
		this.$http.post(this.$root.mainUrl + 'api/colores.php',color).then(result => {
			result.json().then(elem =>{
				let idx=this.getIndex(color);
				this.colores.splice(idx, 1);
				this.snackbar = true;
				this.mensaje = "Color eliminado correctamente";
				this.aEliminar = null;
			});
		}, error => {
			this.showMessage('Ocurrió un error al eliminar el color','error');
			// console.error(error);
		});
	},
	aceptar: function(color){
		if (color.descripcion==null || color.descripcion.trim()==''){
			this.showMessage('La descripción no puede estar vacía','error');
			return;
		}
		color.descripcionBack = null;
		color.editando = false;
		color.operacion = "GUARDAR";
		this.$http.post(this.$root.mainUrl + 'api/colores.php',color).then(result => {
			result.json().then(elem =>{
				if (elem.id!=null){
					color.id=elem.id;
					this.showMessage('Color creado correctamente','success');
				}
				else{
					this.showMessage('Color actualizado correctamente','success');
				}
				this.editando = false;
			});
		}, error => {
			this.showMessage('Ocurrió un error al actualizar el color','error');
			// console.error(error);
		});
	},
	agregarNuevo: function(){
		this.editando = true;
		let color = {editando:true,descripcion:'',id:null};
		this.colores.push(color);
		this.$vuetify.goTo(5000);
	},
	getIndex: function(color){
		for (let i=0;i<this.colores.length;i++){
			if (this.colores[i].id==color.id){
				return i;
			}
		}
		return -1;
	},
	showMessage: function(message,style){
		this.snackColor = style;
		this.mensaje = message;
		this.snackbar = true;
	}
  }
};
</script>
<style>
.page-container{
	padding-top:60px;
}
.fa-fab-icon{
	font-size: 1.5em!important;
}
.btn-very-large{
	height: 66px!important;
	width: 66px!important;
}
.btn-very-large i{
	font-size: 3.5em!important;
}
.color-titulo{
	min-height:40px;
}
.input-color{
	padding-top: 0px!important;
	padding-bottom: 0px!important;
	margin-top: 0px!important;
	margin-bottom: 0px!important;
}
.input-color .v-text-field__details{
	display: none;
}
</style>
